import React from "react";

const Button = ({ children, variant, font, onClick, disabled }) => {
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className={`${font} p-[2px] rounded-md w-full h-full font-star-jedi text-lg lowercase disabled:cursor-not-allowed active:brightness-90 ${variant}`}
    >
      {children}
    </button>
  );
};

export default Button;
